
import { defineComponent, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FileLoader from '@/common/components/UI/TheButtonFileLoader/index.vue'

export default defineComponent({
    components: {
        TheButton,
        FileLoader,
    },
    props: {
        opened: {
            type: Boolean,
            default: false,
        },
        stepNumber: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'submit'],
    setup(_, { emit }) {
        const state = reactive({
            directions: [] as File[],
        })

        //

        const emitSubmit = (files: File[]) => {
            if (!files.length) return
            state.directions = files
            emit('submit', files[0])
        }

        const emitReset = () => {
            state.directions = []
            emit('reset')
        }

        return {
            state,
            //
            emitSubmit,
            emitReset,
        }
    },
})
